<script setup lang="ts">
  import { ref, onMounted, onBeforeUnmount } from 'vue';
  import { viewPromotionEvent, useGoogleTagManager } from '@storefront/storefront';

  defineOptions({
    inheritAttrs: false,
  });

  interface Props {
    header: string;
    products: any[];
    headerType?: string;
    link: string;
    placement: string;
    type: string;
    enableAutoplay?: boolean,
    timeAutoplay?: number | string,
    speed?: number | string,
  }

  const props = defineProps<Props>();

  const parameters = ref({
    breakpoints: {
      1: {
        slidesPerView: 1.5,
        spaceBetween: 10,
        slidesOffsetBefore: 10,
        slidesOffsetAfter: 10,
      },
      576: {
        slidesPerView: 2.5,
        spaceBetween: 10,
        slidesOffsetBefore: 10,
        slidesOffsetAfter: 10,
      },
      768: {
        slidesPerView: 3.5,
        spaceBetween: 10,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 16,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      },
      1400: {
        slidesPerView: 5,
        spaceBetween: 16,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      },
    },
  });

  const gtm = useGoogleTagManager();

  const promotionRef = ref<HTMLElement | null>(null);
  let hasFired = false;
  let observer: IntersectionObserver | null = null;

  onMounted(() => {
    if (!promotionRef.value || hasFired) return;

    observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting && !hasFired) {
          gtm.push(viewPromotionEvent(props));
          hasFired = true;

          observer?.disconnect();
          observer = null;
        }
      },
      {
        threshold: 0.3,
      },
    );

    observer.observe(promotionRef.value);
  });

  onBeforeUnmount(() => {
    observer?.disconnect();
  });
</script>
<template>
  <div ref="promotionRef">
    <SfSection :headerType :link="link || $route('web.product.index')" :title="header">
      <SfProductsCarousel :parameters :products :gtagSaleBlockData="{type, header, placement}" :enableAutoplay :timeAutoplay :speed />
    </SfSection>
  </div>
</template>
